export enum ErrorCode {
  PAYMENT_TYPE_UNACCEPTABLE = 'PAYMENT_TYPE_UNACCEPTABLE',
  INVALID_PHONE_NUMBER = 'INVALID_PHONE_NUMBER',
}
